const TEST_IDS = {
    header: {
        downloadPayroll: 'button-download-payroll',
        generateCertificateDrawer: 'button-open-generate-certificate-drawer'
    },
    extraFilters: {
        cuil: 'filter-cuil',
        name: 'filter-name',
        surname: 'filter-surname',
        contract: 'filter-contract',
        state: 'filter-state'
    },
    generationForm: {
        includesClause: 'check-includes-clause',
        destinationCompanyName: 'input-destination-company-name',
        destinationCuit: 'input-destination-company-cuit',
        selectedOrganism: 'selected-organism',
        employeesListSelector: 'combo-employees-list-selector',
        employeesQuantity: 'employees-quantity',
        radioSomeEmployees: 'radio-some-employees',
        radioAllEmployees: 'radio-all-employees',
        commission: {
            companyName: 'commission-company-name',
            domicile: 'commission-domicile',
            startDate: 'commission-start-date',
            endDate: 'commission-end-date',
            province: 'commission-province',
            city: 'commission-city'
        },
        buttons: {
            generateCertificate: 'button-download-certificate',
            cancel: 'button-cancel'
        }
    }
};

export { TEST_IDS };
